export default "__VITE_ASSET__BzH9yanC__"